import * as React from 'react'

import AlbumPreviewThumbs from '@/components/AlbumPreviewThumbs'
import { AlbumPayload } from '@/constant/types'
import { cn } from '@/lib/utils'

type AlbumsOverviewProps = {
  albums: AlbumPayload[]
  excludeAlbumId?: string
  enableHover?: boolean
  className?: string
}

export default function AlbumsOverview({
  albums,
  excludeAlbumId = '',
  enableHover = true,
  className,
}: AlbumsOverviewProps) {
  return (
    <nav className={cn('', className)}>
      <ul className=''>
        {albums.map(({ slug, title, date, _id, photos }) => {
          if (_id === excludeAlbumId) return null
          return (
            <AlbumPreviewThumbs
              key={_id}
              as='li'
              className='sm:md-24 mb-20 last:mb-0 md:mb-32'
              slug={slug.current}
              title={title}
              date={date}
              photos={photos}
              enableHover={enableHover}
            />
          )
        })}
      </ul>
    </nav>
  )
}
